import type { Store } from "redux";
import { writeAuthenticationSliceToLocalStorage } from "@/Slices/authenticationSlice";
import { writeNmfcDescriptionCacheSliceToLocalStorage } from "@/Slices/nmfcDescriptionCacheSlice";
import type { RootState } from "@/store";

/**
 * Writes each persisted slice to localStorage only when it changed. Every tab
 * shares that storage, so writing on any action let a tab with a stale session
 * put it back over another tab's sign-out or new sign-in.
 */
export function persistSlicesOnChange(target: Store<RootState>): void {
  let lastAuthentication = target.getState().authentication;
  let lastNmfcDescriptionCache = target.getState().nmfcDesciptionCache;

  target.subscribe(() => {
    const state = target.getState();

    if (state.authentication !== lastAuthentication) {
      lastAuthentication = state.authentication;
      writeAuthenticationSliceToLocalStorage(state.authentication);
    }
    if (state.nmfcDesciptionCache !== lastNmfcDescriptionCache) {
      lastNmfcDescriptionCache = state.nmfcDesciptionCache;
      writeNmfcDescriptionCacheSliceToLocalStorage(state.nmfcDesciptionCache);
    }
  });
}
